import { BaseModel } from '~/models/baseModel';

export class BaleMovementModel extends BaseModel {
    public woolInShed:number;
    public sentToBroker:number;
    public tested:number;
    public readyForSale:number;
    public sold:number;
}
